import React, { useRef } from 'react';
import s from '../import.module.css';

const CHOICES = [
  {
    key: 'file',
    title: 'Upload a File',
    desc: 'Upload your expenses and other revenue from a CSV file.',
  },
  {
    key: 'paste',
    title: 'Copy and Paste',
    desc: 'Copy expenses and other revenue from a spreadsheet and paste in the next step.',
  },
];

export default function ChooseSourceStep({ onFile, onPaste, onSample }) {
  const fileRef = useRef(null);

  return (
    <div className={s.imCard}>
      <div className={s.imStep}>Step 1/4</div>
      <div className={s.imQ}>How do you want to import your Expenses &amp; Other Revenue?</div>

      <div className={s.imChoices}>
        {CHOICES.map((c) => (
          <button
            key={c.key}
            className={s.imChoice}
            onClick={() => (c.key === 'file' ? fileRef.current?.click() : onPaste())}
          >
            <div className={s.imChoiceT}>{c.title}</div>
            <div className={s.imChoiceD}>{c.desc}</div>
          </button>
        ))}
      </div>

      <input
        ref={fileRef}
        type="file"
        accept=".csv,.tsv,.txt,text/csv"
        className={s.hidden}
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ''; onFile(f); }}
      />
      <button className={s.imLink} onClick={onSample}>Sample File (CSV)</button>
    </div>
  );
}
